<template>
  <div class="page-shell">
    <div class="page-header">
      <div>
        <p class="page-kicker">PROMOTION DATA</p>
        <h2 class="page-title">短剧投放数据</h2>
        <p class="page-subtitle">按项目切换统计视图，保留导入、导出、同步和隐藏规则等原有能力。</p>
      </div>
    </div>

    <section class="program-tabs glass-panel">
      <div v-if="programList.length" class="tab-list">
        <button
          v-for="target in programList"
          :key="getProgramFlag(target)"
          type="button"
          class="program-tab"
          :class="{ active: activeIndex === getProgramFlag(target) }"
          @click="handleSelect(getProgramFlag(target))"
        >
          <span>{{ target.programName }}</span>
          <small>{{ target.programType == 2 ? '小程序' : '视频号' }}</small>
        </button>
      </div>
      <div v-else class="empty-tabs">
        <span class="loading-mark">○</span>
        <span>正在读取项目列表</span>
      </div>
    </section>

    <IncomeVideoNo
      v-if="programType == 1"
      :is-mini-program="activeIndex"
      :key="'video_' + activeIndex">
    </IncomeVideoNo>

    <IncomeMiniProgram
      v-if="programType == 2"
      :is-mini-program="activeIndex"
      :key="'mini_' + activeIndex">
    </IncomeMiniProgram>
  </div>
</template>

<script>
import IncomeVideoNo from "@/components/IncomeVideoNo.vue";
import IncomeMiniProgram from "@/components/IncomeMiniProgram.vue";
import {listNlProgramInfo} from "@/api/IncomeStatic";

export default {
  name: 'IncomeStatic',
  components: {IncomeMiniProgram, IncomeVideoNo},
  data() {
    return {
      programList: [],
      programType: '1',
      activeIndex: ''
    };
  },
  mounted() {
    this.listProgram();
  },
  methods: {
    getProgramFlag(program) {
      const value = program.programFlag !== undefined && program.programFlag !== null
        ? program.programFlag
        : program.flag;
      return String(value);
    },
    handleSelect(key) {
      this.activeIndex = key;
      const program = this.programList.find(item => String(item.programFlag) === key || String(item.flag) === key);
      this.programType = program ? String(program.programType) : '1';
    },
    listProgram() {
      listNlProgramInfo().then(response => {
        this.programList = response.data || [];
        if (this.programList.length) {
          this.handleSelect(this.getProgramFlag(this.programList[0]));
        }
      });
    },
  }
}
</script>

<style scoped>
.program-tabs {
  border-radius: 16px;
  padding: 12px;
}

.tab-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.program-tab {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  min-width: 148px;
  border: 1px solid rgba(15, 23, 42, .10);
  border-radius: 12px;
  background: rgba(255, 255, 255, .68);
  color: #344054;
  cursor: pointer;
  gap: 4px;
  padding: 12px 14px;
  text-align: left;
  transition: transform .14s ease, border-color .14s ease, background .14s ease, color .14s ease, box-shadow .14s ease;
}

.program-tab:hover,
.program-tab.active {
  border-color: rgba(15, 23, 42, .18);
  background: rgba(255, 255, 255, .96);
  color: #101828;
}

.program-tab.active {
  border-color: #101828;
  background: #101828;
  color: #ffffff;
  transform: scale(1.035);
  box-shadow: 0 10px 28px rgba(15, 23, 42, .16);
}

.program-tab span {
  font-weight: 800;
}

.program-tab small {
  color: #667085;
}

.program-tab.active small {
  color: rgba(255, 255, 255, .72);
}

.empty-tabs {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 54px;
  color: #667085;
}

.loading-mark {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
